import { isNotNullOrUndefined, Optional } from '@vy/utils';
import React, { useCallback, useState } from 'react';
import { VyDialog } from '../../../../../../../components/new-design/feedback/VyDialog';
import { useDialog } from '../../../../../../../hooks/use-dialog';
import { CreateContractDialog } from '../CreateContractDialog';
import { PlanSelectionDialogContent } from './PlanSelectionDialogContent';
import type { PlanSelectionOption } from './plan-selection-dialog-types';

type PlanSelectionDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  initialCustomerId?: string;
};

export const PlanSelectionDialog: React.FC<PlanSelectionDialogProps> = ({
  isOpen,
  onClose,
  initialCustomerId,
}) => {
  const { isDialogOpen, handleOpen: openCreateContractDialog, handleClose: closeCreateContractDialog } = useDialog()

  const [selectedOption, setSelectedOption] = useState<Optional<PlanSelectionOption>>('existing');
  const [selectedPlanId, setSelectedPlanId] = useState<Optional<string>>(null);

  const isSelectFromExisting = selectedOption === 'existing';

  const resetAllStates = useCallback(() => {
    setSelectedOption('existing');
    setSelectedPlanId(undefined);
  }, []);

  const handleDialogClose = useCallback(() => {
    resetAllStates();
    closeCreateContractDialog()
    onClose();
  }, []);

  const handleNext = useCallback(() => {
    onClose();
    openCreateContractDialog()
  }, []);

  const isNextDisabled = selectedOption === 'existing' && !selectedPlanId;


  return (
    <>
      <VyDialog
        open={isOpen}
        onClose={handleDialogClose}
        label="Create a new plan"
        labelDescription="Select one of the options to create your contract"
        ctaText="Next"
        ctaDisabled={isNextDisabled}
        cancelButtonText="Cancel"
        onSubmit={handleNext}
        maxWidth="md"
        disableDividers
        cancelButtonProps={{
          sx: {
            padding: '8px 22px',
            borderRadius: '4px',
            backgroundColor: 'rgba(13, 27, 39, 0.08)',
          },
        }}
        ctaButtonProps={{
          sx: {
            fontSize: '16px',
            padding: '8px 66px',
            borderRadius: '4px',
            fontWeight: 500,
            color: isNextDisabled ? '#D6DBE7' : '#FFF',
            backgroundColor: isNextDisabled ? '#AFB6C4' : '#0D0D48',
            '&:hover': {
              backgroundColor: isNextDisabled ? '#AFB6C4' : '#0D0D48',
            },
          },
        }}
      >
        <PlanSelectionDialogContent
          selectedOption={selectedOption}
          onOptionSelect={setSelectedOption}
          selectedPlanId={selectedPlanId}
          onPlanSelect={setSelectedPlanId}
        />
      </VyDialog>

      <CreateContractDialog
        isOpen={isDialogOpen}
        onClose={handleDialogClose}
        initialCustomerId={initialCustomerId}
        cloneFromPlanId={isSelectFromExisting && isNotNullOrUndefined(selectedPlanId) ? selectedPlanId : undefined}
      />
    </>
  );
};
